import React from 'react'

type IconProps = {
    className?: string
}

export const UsersIcon: React.FC<IconProps> = ({ className }) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M10.6836 13.7138L10.6838 11.5713C10.6839 10.3879 9.72455 9.42842 8.5411 9.42842H3.74294C2.55965 9.42842 1.60037 10.3876 1.60024 11.5709L1.6 13.7138M14.3998 13.7139L14.4 11.5714C14.4001 10.388 13.4408 9.42853 12.2573 9.42853M10.2709 2.70701C10.7971 3.09744 11.1381 3.72334 11.1381 4.42889C11.1381 5.13444 10.7971 5.76035 10.2709 6.15077M8.3292 4.42878C8.3292 5.61216 7.36988 6.57148 6.18649 6.57148C5.00311 6.57148 4.04379 5.61216 4.04379 4.42878C4.04379 3.24539 5.00311 2.28607 6.18649 2.28607C7.36988 2.28607 8.3292 3.24539 8.3292 4.42878Z"
            stroke="#3E5060"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
